module.exports = __webpack_public_path__ + "img/img-1.37120c6b.svg";